import { routePath } from "../../routes/routePath";

export const pageInfoRecruit = {
  root: [
    { name: "ホームページ", url: routePath.homepage },
    { name: "採用情報", url: routePath.recruit },
  ],
  pageHeader: "採用情報",
};
